import { DraggableTypesEnum } from 'constants/builder/enums';
import { v4 as generateId } from 'uuid';

import type { QuestionnaireItems } from '../types';

export const addClauseVariationsHelper = (
    questions: QuestionnaireItems,
    blockId: string,
    clauseId: string,
    data: any[]
) => {
    let modifiedQuestions: QuestionnaireItems;

    const hasBlockVariations = questions.some(
        item => item.blockId === blockId && item.questionType === DraggableTypesEnum.Block
    );

    if (hasBlockVariations) {
        modifiedQuestions = questions.map(question => {
            if (question.clauseId === clauseId) {
                return {
                    ...question,
                    isShown: false
                };
            }

            return question;
        });
    } else {
        modifiedQuestions = questions.map(question => {
            if (question.clauseId === clauseId && question.questionType !== DraggableTypesEnum.Clause) {
                return {
                    ...question,
                    isShown: false
                };
            }

            return question;
        });
    }

    const hasClauseVariations = modifiedQuestions.find(
        item => item.clauseId === clauseId && item.questionType === DraggableTypesEnum.Clause
    );

    if (!hasClauseVariations) {
        return [
            ...modifiedQuestions,
            {
                questionType: DraggableTypesEnum.Clause,
                description: data[0][0].description,
                isShown: !hasBlockVariations,
                title: data[0][0].title,
                type: data[0][0].type,
                variationsField: data,
                id: generateId(),
                clauseId,
                blockId
            }
        ];
    }

    return questions.map(item => {
        if (item.clauseId === clauseId && item.questionType === DraggableTypesEnum.Clause) {
            return {
                ...item,
                description: data[0][0].description,
                title: data[0][0].title,
                type: data[0][0].type,
                variationsField: data
            };
        }

        return item;
    });
};
